import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { submitContactForm } from '../../services/api';
import Breadcrumb from '../../components/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import './ShoppingCart.scss';

const ShoppingCartPage = () => {
  const { cartItems, clearCart, removeFromCart } = useCart();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const solutionsList = cartItems.map(item => `- ${item.title} (${item.type})`).join('\n');
    const message = `Interest in the following solutions:\n\n${solutionsList}`;

    try {
      await submitContactForm({
        ...formData,
        subject: 'Solutions Interest',
        message,
      });
      setSubmitStatus('success');
      setIsSubmitted(true);
      clearCart();
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/cart', label: 'Shopping Cart' },
  ];

  if (isSubmitted) {
    return (
      <div className="shopping-cart-page">
        <Breadcrumb items={breadcrumbItems} />
        <section className="page-header">
          <div className="container">
            <h1 className="page-header__title">Thank You!</h1>
          </div>
        </section>
        <section className="section section--light">
          <div className="container">
            <div className="thank-you-message">
              <h2>Thank you for expressing interest in our products!</h2>
              <p>We will get back to you within 24 hours to discuss your requirements.</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="shopping-cart-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Shopping Cart</h1>
          <p className="page-header__subtitle">
            Review your selected solutions and services, fill out the contact information form, and
            let's start the conversation! We'll get back to you within 24 hours maximum.
          </p>
        </div>
      </section>

      <section className="section section--light">
        <div className="container">
          {cartItems.length === 0 ? (
            <div className="empty-cart-message">
              <h2>Your cart is empty</h2>
              <p>Browse our solutions and services to find the perfect fit for your needs.</p>
            </div>
          ) : (
            <div className="cart-checkout-container">
              <div className="cart-items">
                <h2>Your Selection</h2>
                <ul className="cart-items-list">
                  {cartItems.map(item => (
                    <li key={item.id} className="cart-item">
                      <div className="item-info">
                        <h3>{item.title}</h3>
                        <p>{item.type}</p>
                      </div>
                      <button
                        className="remove-item"
                        onClick={() => removeFromCart(item.id)}
                        aria-label="Remove item"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="checkout-form">
                <h2>Provide Your Contact Information</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Your full name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Your email address"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Your phone number (optional)"
                    />
                  </div>

                  <button type="submit" className="btn btn--primary" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit Request'}
                  </button>

                  {submitStatus === 'success' && (
                    <div className="submit-status success">
                      Your request has been submitted successfully.
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="submit-status error">
                      Sorry, there was an error submitting your request. Please try again later.
                    </div>
                  )}
                </form>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ShoppingCartPage;
